<div class='fullcontainer'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Account was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit {{ this.getTitle() }} - {{ this.account.name }}/{{ this.account.accountRef }}</h1>
    <app-audit-line [data]='this.account'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-accounts-form [account]='this.account' [creditLimit]='this.creditLimit' [tippingPrices]='this.tippingPrices' [customerDetails]='this.customerDetails' [tipDetails]='this.tipDetails' [depotDetails]='this.depotDetails'></app-accounts-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/accounts'>Cancel</button>
    </form>
  </div>
</div>
